// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { productInformationStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productInformationStyles.descriptionStyles = {
    productDetailLink: {
        css: css`
            width: 100%;
        `,
        typographyProps: {
            size: 18,
            weight: 600,
            color: "secondary.main",
            css: css`
                color: ${getColor("secondary.main")} !important;
            `,
        },
    },
};

productInformationStyles.partNumbersStyles = {
    erpNumberLabelText: {
        css: css`
            margin-right: 7px;
        `,
        weight: "normal",
    },
    customerNameLabelText: {
        css: css``,
        weight: "normal",
    },
    manufacturerItemLabelText: {
        css: css`
            margin-right: 7px;
        `,
        weight: "normal",
    },
};
